var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcLogicGAppExclamationMark = function SvgIcLogicGAppExclamationMark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "\\u30EC\\u30A4\\u30E4\\u30FC_1",
    x: 0,
    y: 0,
    viewBox: "0 0 30 30"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{fill:#fff}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 18.682c.93 0 1.685-.753 1.686-1.683V6.427a1.686 1.686 0 0 0-3.372 0v10.57c0 .93.755 1.685 1.686 1.685M15 21.248a2.333 2.333 0 1 0 0 4.666 2.333 2.333 0 0 0 0-4.666",
    className: "st0"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h30v30H0z",
    style: {
      fill: "none"
    }
  }));
};
export default SvgIcLogicGAppExclamationMark;